<template>
  <div class="row">
    <div class="col-12">
      <div class="_table">
        <b-table
          :fields="fields"
          :items="items"
        >
          <template #cell(status)="{item}">
            <span v-if="item.status === 4">
              {{$t('messageStatus.managerMoneyManageStatus2')}}
            </span>
            <span v-if="item.status === 5">
              {{$t('messageStatus.managerMoneyManageStatus3')}}
            </span>
          </template>
          <template #cell(actions)="{item}">
            <b-button 
              v-if="item.status === 3"
              variant="success"
              size="sm"
              @click="acceptedModalOpen(item.id)"
            >
              <i class="bx bx-check-circle fs-4" ></i>
            </b-button>

            <b-button
              v-if="item.status === 3"
              variant="danger"
              size="sm"
              @click="rejectModalOpen(item.id)"
            >
              <i class="bx bx-minus-circle fs-4" ></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>

    <b-modal
      v-model="acceptedModalBool"
      hide-footer
      hide-header
    >
      <AcceptModal 
        :id="id"
        @onClose="acceptedModalClose"
      />
    </b-modal>

    <b-modal
      v-model="rejectModalBool"
      hide-footer
      hide-header
    >
      <RejectModal 
        :id="id"
        @onClose="rejectModalClose"
      />
    </b-modal>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import AcceptModal from './components/acceptedModal.vue';
  import RejectModal from './components/rejectModal.vue';

  export default {
    name: "Manager-ManageIncomDeliveries",
    components: {
      AcceptModal,
      RejectModal
    },
    data() {
      return {
        fields: [
          {key: "id", label: "№"},
          {key: "date", label: this.$t('table.date')},
          {key: "driver.full_name", label: this.$t('table.driver.label')},
          {key: "product.name", label: this.$t('table.product.label')},
          {key: "quantity", label: this.$t('table.quantity.label')},
          {key: "status", label: this.$t('table.status.label')},
          {key: "actions", label: this.$t('table.actions.label'), class: "d-flex gap-1"},
        ],
        acceptedModalBool: false,
        id: null,
        rejectModalBool: false,
      }
    },
    methods: {
      ...mapActions('managerManageIncomDeliveries', ['fetchData']),
      acceptedModalOpen(id) {
        this.id = id;
        this.acceptedModalBool = true;
      },
      acceptedModalClose() {
        this.acceptedModalBool = false;
        this.fetchData();
      },
      rejectModalOpen(id) {
        this.id = id;
        this.rejectModalBool = true;
      },
      rejectModalClose() {
        this.rejectModalBool = false;
        this.fetchData();
      }
    },
    mounted() {
      this.fetchData();
    },
    computed: {
      ...mapGetters('managerManageIncomDeliveries', ['items'])
    }
  }
</script>